import { render, staticRenderFns } from "./OrderSuccessModal.vue?vue&type=template&id=7cec882d&"
import script from "./OrderSuccessModal.vue?vue&type=script&lang=js&"
export * from "./OrderSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports